import { computed, ComputedRef } from "vue"
import { ApplyDecisionProps } from "@/models/apply/apply-models"

export function useApplyDecisionViewType(
  props: ApplyDecisionProps
): ComputedRef<string> {
  return computed(() => (props.transitioning ? "transitioning" : "view"))
}
